import dataLayer from '../../utils/data-layer';

export default {
    elements: document.querySelectorAll('[data-layer-event]'),
    init() {
        if (this.elements.length === 0 || typeof window.dataLayer == 'undefined') {
            return;
        }

        this.elements.forEach(dataLayer);
    },
    /**
     *
     * @param {Element} html
     */
    refreshDOM(html) {
        if (html.hasAttribute('data-layer-event')) {
            dataLayer(html);
        }

        html.querySelectorAll('[data-layer-event]').forEach(dataLayer);
    },
};
